import fetchExpresso from 'utility/fetchExpresso';

async function parseResponse(response) {
    if (response.ok) {
        return response.status === 204 ? null : response.json().catch(() => ({}));
    }

    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Unable to save onsite role');
}

export async function getOnsiteRoles(eventId) {
    return parseResponse(await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles`));
}

export async function createOnsiteRole(eventId, role) {
    return parseResponse(
        await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles`, {
            method: 'POST',
            body: role,
        }),
    );
}

export async function updateOnsiteRole(eventId, roleId, role) {
    return parseResponse(
        await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles/${roleId}`, {
            method: 'PUT',
            body: role,
        }),
    );
}

export async function updateOnsiteRoleSort(eventId, sort) {
    return parseResponse(
        await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles/sort`, {
            method: 'PUT',
            body: { sort },
        }),
    );
}

export async function deleteOnsiteRole(eventId, roleId) {
    return parseResponse(
        await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles/${roleId}`, {
            method: 'DELETE',
        }),
    );
}

export async function getOnsiteRoleProducts(eventId) {
    const data = await parseResponse(
        await fetchExpresso(`/apiv2/events/${eventId}/onsite-roles/products`),
    );
    return data.products;
}
